
// Gallery side scroller on scroll
document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  gsap.registerPlugin(ScrollTrigger);

  var galleries = document.querySelectorAll('.grid.sidescroll-gallery');

  for (var i = 0; i < galleries.length; i++) {
    initHorizontalGallery(galleries[i], i);
  }

  function initHorizontalGallery(grid, index) {
    var viewport = grid.querySelector('.container-fluid');
    var track = grid.querySelector('.row');

    if (!viewport || !track) {
      return;
    }

    function build() {
      var triggerId = 'gallery-horizontal-' + index;
      var existing = ScrollTrigger.getById(triggerId);

      if (existing) {
        existing.kill();
      }

      gsap.killTweensOf(track);
      gsap.set(track, { clearProps: 'transform' });
      gsap.set(track, { x: 0 });

      var moveAmount = track.scrollWidth - viewport.clientWidth;
      var maxMove = Math.min(moveAmount, 250);

      if (maxMove <= 0) {
        return;
      }

      var initialOffset = 50;

      ScrollTrigger.create({
        id: triggerId,
        trigger: grid,
        start: "top 100%",
        end: "bottom 15%",
        scrub: true,
        invalidateOnRefresh: true,

        onUpdate: function (self) {
          gsap.set(track, {
            x: -(initialOffset + (maxMove - initialOffset) * self.progress),
          });
        },

        onLeaveBack: function () {
          gsap.set(track, { x: 0 });
        },
      });
    }

    build();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        build();
        ScrollTrigger.refresh();
      }, 150);
    });
  }

  ScrollTrigger.refresh();
});


// Parallax image
document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var sections = document.querySelectorAll('.parallax-img');

  for (var i = 0; i < sections.length; i++) {
    initParallaxImage(sections[i], i);
  }

  function initParallaxImage(section, index) {
    var inner = section.querySelector('.inner');
    var img = section.querySelector('.inner img');

    if (!inner || !img) {
      return;
    }

    var triggerId = 'parallax-img-' + index;

    function build() {
      var existing = ScrollTrigger.getById(triggerId);

      if (existing) {
        existing.kill();
      }

      gsap.killTweensOf(img);
      gsap.set(img, { clearProps: 'transform' });
      gsap.set(img, { y: 0 });

      var moveAmount = Math.round(inner.offsetHeight * 0.1);

      ScrollTrigger.create({
        id: triggerId,
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
        // markers: true,

        onUpdate: function(self) {
          gsap.set(img, {
            y: moveAmount - (moveAmount * 2 * self.progress)
          });
        },

        onLeaveBack: function() {
          gsap.set(img, { y: -moveAmount });
        }
      });
    }

    build();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        build();
        ScrollTrigger.refresh();
      }, 150);
    });
  }

  ScrollTrigger.refresh();
});

// Parallax image background
document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var sections = document.querySelectorAll('.parallax-img-bg');

  for (var i = 0; i < sections.length; i++) {
    initParallaxBg(sections[i], i);
  }

  function initParallaxBg(section, index) {
    var inner = section.querySelector('.inner');
    if (!inner) return;

    var bgImage = section.getAttribute('data-bg');

    if (bgImage) {
      section.style.setProperty('--parallax-bg-image', 'url("' + bgImage + '")');
    }

    var triggerId = 'parallax-bg-' + index;

    function build() {
      var existing = ScrollTrigger.getById(triggerId);

      if (existing) {
        existing.kill();
      }

      var moveAmount = Math.round(inner.offsetHeight * 0.4);
      var baseOffset = -20;

      section.style.setProperty('--bg-parallax-y', (baseOffset + moveAmount) + 'px');

      ScrollTrigger.create({
        id: triggerId,
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
        // markers: true,

        onUpdate: function(self) {
          var y = baseOffset + moveAmount - (moveAmount * 2 * self.progress);
          section.style.setProperty('--bg-parallax-y', y + 'px');
        },

        onLeaveBack: function() {
          section.style.setProperty('--bg-parallax-y', (baseOffset + moveAmount) + 'px');
        }
      });
    }

    build();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        build();
        ScrollTrigger.refresh();
      }, 150);
    });
  }

  ScrollTrigger.refresh();
});




// New Word Effect .word-effect h1
document.addEventListener('DOMContentLoaded', function() {
  var headings = document.querySelectorAll('.letter-effect h1');

  for (var i = 0; i < headings.length; i++) {
    splitHeading(headings[i]);
  }

  function splitHeading(heading) {
    if (!heading) return;

    var text = heading.textContent || heading.innerText || '';
    var words = text.trim().split(/\s+/);
    var html = '';
    var delayStep = 0.03;
    var letterIndex = 0;
    var i, j, word, char;

    for (i = 0; i < words.length; i++) {
      word = words[i];
      html += '<span class="word">';

      for (j = 0; j < word.length; j++) {
        char = word.charAt(j);
        html += '<span class="char" style="animation-delay:' + (letterIndex * delayStep) + 's;">' + escapeHtml(char) + '</span>';
        letterIndex++;
      }

      html += '</span>';

      if (i < words.length - 1) {
        html += ' ';
        letterIndex++;
      }
    }

    heading.innerHTML = html;
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
});





document.addEventListener("DOMContentLoaded", function () {
  var wordSections = toArray(
    document.querySelectorAll(".word-effect")
  );

  var twoColumnSections = toArray(
    document.querySelectorAll(".two-col-fade")
  );

  var scrollController = window.controller;

  if (!scrollController) {
    scrollController = new ScrollMagic.Controller();
    window.controller = scrollController;
  }

  var animationScenes = [];

  /*
   * Split all headlines before creating animations.
   */
  wordSections.forEach(function (section) {
    prepareWordEffect(section);
  });

  /*
   * Respect reduced-motion preferences.
   */
  if (
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }

  /*
   * Two-column animations.
   */
  twoColumnSections.forEach(function (section) {
    var firstColumn = section.querySelectorAll(
      ".col-first .inner"
    );

    var secondColumn = section.querySelectorAll(
      ".col-second"
    );

    var timeline = new TimelineMax();

    if (firstColumn.length) {
      timeline.fromTo(
        firstColumn,
        0.8,
        {
          autoAlpha: 0,
          x: -10
        },
        {
          autoAlpha: 1,
          x: 0,
          ease: Power2.easeOut
        },
        0
      );
    }

    if (secondColumn.length) {
      timeline.fromTo(
        secondColumn,
        0.8,
        {
          autoAlpha: 0,
          x: 10
        },
        {
          autoAlpha: 1,
          x: 0,
          ease: Power2.easeOut
        },
        0.25
      );
    }

    /*
     * Find word effects applied either to the two-column
     * section itself or nested inside it.
     */
    var nestedWordSections = [];

    if (section.classList.contains("word-effect")) {
      nestedWordSections.push(section);
    }

    nestedWordSections = nestedWordSections.concat(
      toArray(section.querySelectorAll(".word-effect"))
    );

    nestedWordSections.forEach(function (
      wordSection,
      index
    ) {
      /*
       * Prevent this section from receiving a second,
       * standalone ScrollMagic scene.
       */
      wordSection.setAttribute(
        "data-word-effect-attached",
        "true"
      );

      addWordEffectToTimeline(
        timeline,
        wordSection,
        index === 0 ? 0.35 : "-=0.25"
      );
    });

    new ScrollMagic.Scene({
      triggerElement: section,
      triggerHook: "onEnter",
      duration: 0,
      offset: 150
    })
      .setTween(timeline)
      .setClassToggle(section, "active")
      .addTo(scrollController);
  });

  /*
   * Standalone word effects.
   */
  wordSections.forEach(function (section) {
    if (
      section.getAttribute("data-word-effect-attached") ===
      "true"
    ) {
      return;
    }

    var timeline = new TimelineMax({
      delay: 0.3
    });

    addWordEffectToTimeline(timeline, section, 0);

    var wordScene = new ScrollMagic.Scene({
      triggerElement: section,
      triggerHook: 0.9,
      duration: 0,
      offset: 0,
      reverse: false
    })
      .setTween(timeline)
      .setClassToggle(section, "active")
      .addTo(scrollController);

    animationScenes.push(wordScene);
      });

  /**
   * Prepare every headline inside a word-effect section.
   */
  function prepareWordEffect(section) {
    if (
      section.getAttribute("data-word-effect-ready") ===
      "true"
    ) {
      return;
    }

    var headlines = section.querySelectorAll(".headline");

    for (var i = 0; i < headlines.length; i++) {
      splitHeadingWords(headlines[i]);
    }

    section.setAttribute(
      "data-word-effect-ready",
      "true"
    );

    section.classList.add("is-ready");
  }

  /**
   * Add the headline, description and button animations
   * to any supplied TimelineMax instance.
   */
  function addWordEffectToTimeline(
    timeline,
    section,
    position
  ) {
    var words = section.querySelectorAll(
      ".headline .word"
    );

    var fadeInHeadlines = section.querySelectorAll(
      ".headline-fade-in"
    );

    var descriptions = section.querySelectorAll(
      "p.desc"
    );

    var buttons = section.querySelectorAll(
      "a.butt"
    );

    /*
    * Set every starting state before the timeline plays.
    */
    if (words.length) {
      TweenMax.set(words, {
        autoAlpha: 0,
        y: 24,
        scale: 1.015,
        filter: "blur(10px)",
        force3D: true
      });

      timeline.staggerTo(
        words,
        1.2,
        {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          filter: "blur(0px)",
          ease: Power4.easeOut
        },
        0.1,
        position
      );
    }

    /*
    * Fade this heading in after the words finish.
    */
    if (fadeInHeadlines.length) {
      TweenMax.set(fadeInHeadlines, {
        autoAlpha: 0,
        y: 8,
        force3D: true
      });

      timeline.staggerTo(
        fadeInHeadlines,
        0.6,
        {
          autoAlpha: 1,
          y: 0,
          ease: Power2.easeOut
        },
        0.1,
        words.length ? "-=0.7" : position
      );
    }

    /*
    * Description begins near the end of the secondary
    * headline fade.
    */
    if (descriptions.length) {
      TweenMax.set(descriptions, {
        autoAlpha: 0,
        y: 16,
        force3D: true
      });

      timeline.staggerTo(
        descriptions,
        0.7,
        {
          autoAlpha: 1,
          y: 0,
          ease: Power2.easeOut
        },
        0.1,
        words.length || fadeInHeadlines.length
          ? "-=0.25"
          : position
      );
    }

    if (buttons.length) {
      TweenMax.set(buttons, {
        autoAlpha: 0,
        y: 12,
        force3D: true
      });

      timeline.staggerTo(
        buttons,
        0.65,
        {
          autoAlpha: 1,
          y: 0,
          ease: Power2.easeOut
        },
        0.1,
        "-=0.3"
      );
    }
  }

  /**
   * Split a plain-text headline into individual words.
   */
  function splitHeadingWords(heading) {
    if (
      !heading ||
      heading.getAttribute("data-words-split") === "true"
    ) {
      return;
    }

    var text = heading.textContent || "";
    var words = text.trim().split(/\s+/);
    var fragment = document.createDocumentFragment();

    heading.innerHTML = "";

    for (var i = 0; i < words.length; i++) {
      var word = document.createElement("span");

      word.className = "word";
      word.textContent = words[i];

      fragment.appendChild(word);

      if (i < words.length - 1) {
        fragment.appendChild(
          document.createTextNode(" ")
        );
      }
    }

    heading.appendChild(fragment);

    heading.setAttribute("data-words-split", "true");
  }

  function toArray(items) {
    return Array.prototype.slice.call(items);
  }

  window.addEventListener("load", function () {
  animationScenes.forEach(function (scene) {
    scene.refresh();
  });

  scrollController.update(true);
});
});